/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TChatsMoveToSpamDesktopModel,
  IChatsMoveToSpamDesktopRequest,
  IMappers,
  IChatsMoveToSpamDesktopResponse,
  IChatsMoveToSpamDesktopResponseError,
  TChatsMoveToSpamDesktopResponse,
} from './types';

const defaultConfig: TChatsMoveToSpamDesktopModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'chats',
  pathApi: '/v1/chats/move-to-spam-desktop/',
  hostType: 'api',
} as TChatsMoveToSpamDesktopModel;

function createChatsMoveToSpamDesktopModel(parameters: IChatsMoveToSpamDesktopRequest): TChatsMoveToSpamDesktopModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IChatsMoveToSpamDesktopOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IChatsMoveToSpamDesktopRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchChatsMoveToSpamDesktop<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IChatsMoveToSpamDesktopOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TChatsMoveToSpamDesktopResponse
> {
  const { response, statusCode } = await httpApi.fetch(createChatsMoveToSpamDesktopModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IChatsMoveToSpamDesktopResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IChatsMoveToSpamDesktopResponseError);
    }
  }

  return { response, statusCode } as TChatsMoveToSpamDesktopResponse;
}

export { defaultConfig, createChatsMoveToSpamDesktopModel, fetchChatsMoveToSpamDesktop };
